module.exports = __webpack_public_path__ + "static/media/polygon.eb0fd77a.svg";